//import store from "../../store/index";

import apiOffice from "../axios/apiOffice";

class FilesService {
  static async saveFile(formData) {
    try {
      const response = await apiOffice.post(
        `/files/procedure-upload`,
        formData
      );
      if (response.status < 300) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error saving file:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async saveObservationFile(formData) {
    try {
      const response = await apiOffice.post(
        `/files/observations-upload`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      if (response.status < 300) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error saving observation file:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }
}

export default FilesService;
